import { ServerConfig } from "@/config/config";
import { BrowseExtraButton } from "@/models/browse-extra-button";
import { Axios } from "./auth-service";

class BrowseExtraButtonServiceClass {
	getUrl(dossierId:number, buttonId?:number):string{
		let baseUrl = `${ServerConfig.mainAppHost}/dossier/${dossierId}/browse-extra-buttons`;
		if (buttonId != undefined) {
			return `${baseUrl}/${buttonId}`;
		}
		return baseUrl;
	}

	async getAllButtons(dossierId:number):Promise<BrowseExtraButton[]>{
		let result = await Axios.get(this.getUrl(dossierId));
		return ((result.data || []) as any[]).map(d=>new BrowseExtraButton(d));
	}

	async getButton(dossierId:number, buttonId:number):Promise<BrowseExtraButton>{
		let result = await Axios.get(this.getUrl(dossierId, buttonId));
		return new BrowseExtraButton(result.data);
	}

	async createButton(dossierId:number, button:BrowseExtraButton):Promise<BrowseExtraButton>{
		let result = await Axios.post(this.getUrl(dossierId), button.getJSON());
		return new BrowseExtraButton(result.data);
	}

	async editButton(dossierId:number, button:BrowseExtraButton):Promise<BrowseExtraButton>{
		let result = await Axios.put(this.getUrl(dossierId, button.ID), button.getJSON());
		return new BrowseExtraButton(result.data);
	}

	async deleteButton(dossierId:number, button:BrowseExtraButton):Promise<void>{
		await Axios.delete(this.getUrl(dossierId, button.ID));
	}
}

export const BrowseExtraButtonService = new BrowseExtraButtonServiceClass();